<script lang="ts" setup>
import type { PropType } from 'vue'

defineProps({
	theme: {
		type: String,
		default: 'black',
	},
	content: {
		type: null as unknown as PropType<string>,
		required: true,
	},
	isShow: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['dismiss'])

function dismiss() {
	emit('dismiss')
}
</script>
<template>
	<transition name="bs-snack-bar--animation">
		<div
			class="bs-snack-bar"
			:class="`bs-snack-bar__theme--${theme}`"
			v-if="isShow"
		>
			<p class="bs-snack-bar__content">{{ content }}</p>
			<i class="bs-snack-bar__dismiss" @click="dismiss"></i>
		</div>
	</transition>
</template>
